export const logError = (
  error: any,
  functionName?: string,
  additionalData?: any,
) => {
  if (process.env.NODE_ENV === 'development') {
    if (functionName) {
      console.error(`Logger/Error in ${functionName}:`, error.message || error);
    } else {
      console.error('Logger/Error:', error.message || error);
    }
    if (error.stack) {
      console.error('Logger/Stack Trace:', error.stack);
    }
    if (additionalData) {
      console.error('Logger/Additional Data:', additionalData);
    }
  }
};
export const logInfo = (
  message: string,
  functionName?: string,
  additionalData?: any,
) => {
  if (process.env.NODE_ENV === 'development') {
    if (functionName) {
      console.info(`Logger/Info from ${functionName}:`, message);
    } else {
      console.info('Logger/Info:', message);
    }
    if (additionalData) {
      console.info('Logger/Additional Data:', additionalData);
    }
  }
};
export const logWarning = (
  message: string,
  functionName?: string,
  additionalData?: any,
) => {
  if (process.env.NODE_ENV === 'development') {
    if (functionName) {
      console.warn(`Logger/Warning from ${functionName}:`, message);
    } else {
      console.warn('Logger/Warning:', message);
    }
    if (additionalData) {
      console.warn('Logger/Additional Data:', additionalData);
    }
  }
};
export const logDebug = (
  message: string,
  functionName?: string,
  additionalData?: any,
) => {
  if (process.env.NODE_ENV === 'development') {
    if (functionName) {
      console.debug(`Logger/Debug from ${functionName}:`, message);
    } else {
      console.debug('Logger/Debug:', message);
    }
    if (additionalData) {
      console.debug('Logger/Additional Data:', additionalData);
    }
  }
};
